import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { GENERATION_TOOL__general__image_aspect_ratio } from '../general/GENERATION_TOOL__general__image_aspect_ratio';
import { GENERATION_TOOL__sd1__master } from '../sd_1/GENERATION_TOOL__sd1__master';
import { GENERATION_TOOL__image_edit__rembg } from './GENERATION_TOOL__image_edit__rembg';
import { GENERATION_TOOL__image_edit__trim_color } from './GENERATION_TOOL__image_edit__trim_color';
import { GENERATION_TOOL__image_edit__upscale } from './upscale/GENERATION_TOOL__image_edit__upscale';
import { GENERATION_TOOL__image_edit__upscale_to_side } from './upscale/GENERATION_TOOL__image_edit__upscale_to_side';

export function FN_GENERATION_TOOL__create_map__image_edit() {
  /*
   *
   */

  /*
   *
   */

  let out = new MAP__serializable<string, DTO__generation_tool>();

  DTO__generation_tool.CREATE_TO_MAP(out, () => GENERATION_TOOL__general__image_aspect_ratio(ENUM__image_asset_category.IMAGE));
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__image_edit__rembg);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__image_edit__upscale.create);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__image_edit__upscale_to_side.create);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__image_edit__trim_color);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__sd1__master.create);

  return out;
}
